import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '.';
import { CONTROLLERS, ENDPOINTS } from '../constants';
import { DataContext, Response } from '../models';
@Injectable({
  providedIn: 'root',
})
export class DataContextService {
  private api: string = CONTROLLERS.DATA_CONTEXT;
  constructor(private apiService: ApiService) {}

  getDataContextByPMSId(PMSId: number): Observable<Response<DataContext[]>> {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.DATA_CONTEXT.GET_LIST_BY_PMS_ID}/${PMSId}`
    );
  }
}
